package team.platforma.chat_presentation.model

import org.koin.core.scope.ScopeID

data class Chat(
    val id: Long,
    val aiModelId: Long,
    val userId: Long,
    val name: String
)
